import { Directive, effect, inject, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { LinkStyles, TextStyles, applyTextLinkCustomStyles } from '@flowx/core-theme'

import { ComponentType } from '../injectors'

@Directive({
  selector: '[flxText],[flxLink]',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxTextLinkStyleDirective {
  #component = inject(ComponentType, { self: true, optional: true })

  componentStyle = input<{
    style: TextStyles | LinkStyles
    conditionalStyles: Array<TextStyles | LinkStyles>
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const className = await applyTextLinkCustomStyles(
        {
          styles: this.componentStyle().style,
          conditionalStyles: this.componentStyle().conditionalStyles,
        },
        theme(),
        fonts(),
        this.#component as 'text' | 'link'
      )
      this.styleClassName.set(className)
    })
  }
}
